import React from 'react';
import * as S from './styles';
import type { Props as PropsInputAutoComplete } from './InputAutoComplete';
type ListProps<V> = {
  renderSugestions?: any[];
  debouncedQuery?: string;
  loadingSuggestions?: boolean;
  noResultsMessage?: PropsInputAutoComplete<V>['noResultsMessage'];
  selectedIndex?: number;
  renderOption?: {
    (v: V, q?: string): string | React.ReactNode;
  };
  listFooter?: PropsInputAutoComplete<V>['listFooter'];
  suggestions?: any[];
  onSuggestionClick: (e: any, suggestion: any) => void;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
  withDefaultPaddingOption?: boolean;
  listContainerWidth?: string;
};
function ListDataItems<P>(props: ListProps<P>): JSX.Element {
  const {
    debouncedQuery,
    listFooter,
    loadingSuggestions,
    noResultsMessage,
    renderOption,
    renderSugestions,
    selectedIndex,
    suggestions,
    onSuggestionClick,
    setSelectedIndex,
    withDefaultPaddingOption = true,
    listContainerWidth
  } = props;
  return <S.ListData key="suggestions" id="list" width={listContainerWidth} data-testid="destinations-suggestions-list">
      {renderSugestions.length < 1 && debouncedQuery && loadingSuggestions === false ? <>
          {!noResultsMessage || typeof noResultsMessage == 'string' ? <S.NotFound>
              <p>{noResultsMessage || '(' + "Nenhum resultado encontrado - por favor, tente novamente" + ')'}</p>
            </S.NotFound> : noResultsMessage}
        </> : renderSugestions?.map((suggestion, index) => {
      const {
        noClick
      } = suggestion;
      return <a href="#" key={index} tabIndex={-1} onClick={e => {
        if (noClick) return;
        onSuggestionClick(e, suggestion);
        setSelectedIndex(index);
      }} onMouseDown={e => {
        if (noClick) return;
        onSuggestionClick(e, suggestion);
        setSelectedIndex(index);
      }} className={`${index == selectedIndex ? 'selected' : ''} ${withDefaultPaddingOption ? 'withDefaultPaddingOption' : ''}`}>
              {renderOption(suggestion, debouncedQuery)}
            </a>;
    })}
      {listFooter && suggestions?.length && listFooter() || null}
    </S.ListData>;
}
export default ListDataItems;